import { Component, OnInit, Inject, Input, LOCALE_ID, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { async } from '@firebase/util';
import { ArticleService } from 'src/app/service/article.service';
import { OrderConfirmationComponent } from 'src/app/service/order-confirmation/order-confirmation.component';
import { OrderFailedComponent } from 'src/app/service/order-failed/order-failed.component';
import { OrderService } from 'src/app/service/order.service';
import { PaymentService } from 'src/app/service/payment.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { AlertComponent } from '../alert/alert.component';
declare let Klarna: any; //declare Klarna
declare var paypal: any; //declare PayPal


@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    public dialogRef: MatDialogRef<CheckoutComponent>,
    public matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private orderService: OrderService,
    private paymentService: PaymentService,
    private fb: FormBuilder,
    private profileService: ProfileService,
    private articleService: ArticleService
  ) { }

  state: number = 0;
  payment = this.fb.group({
    order: new FormControl(''),
    payment_method: new FormControl('')
  });
  @Input() order: any;
  @ViewChild('paypal', {static: true}) paypalElement: ElementRef;
  klarnaObj: any;
  klarnaAvailable: boolean;
  klarnaClientToken: any;
  klarnaAuthorization_token: string;
  orderId: any;
  currencyRate: any = 1;
  // currencyRate: any;


  orderConfirmationWindow(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "orderConfrimation";
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      orderNr: this.orderId,
    }
    const modalDialog = this.matDialog.open(OrderConfirmationComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      this.dialogRef.close();
    })
  }

  orderFailedWindow(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.id = "order-failed-component";
    const modalDialog = this.matDialog.open(OrderFailedComponent, dialogConfig);
  }

  async saveOrder(): Promise<string> {
    let promiseString: any;
    let order = {
      settings_id: '',
      status_id: 0,
      created_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
      shipment_method_id: this.order.shipment_method_id,
      payment_method_id: this.payment.value.payment_method,
      product_price: this.order.product_price,
      price: parseFloat(this.order.product_price)* this.order.quantity + parseFloat(this.order.shipping_price) + parseFloat(this.order.VAT),
      shipping_price: this.order.shipping_price,
      vat: this.order.VAT,
      country: this.order.country.country_code,
      shipping_address: '',
      billing_address: '',
      phone_nr: this.order.phone_nr,
      articles: this.order.articles,
      coustumerMessage: this.order.coustumerMessage,
      discount_id: this.order.discount_id,
      oid: this.order.oid,
      first_name: this.order.first_name,
      last_name: this.order.last_name,
      email: this.order.email
    }
    if(this.order.otherShippingAddress){

      order.shipping_address = this.order.shipping_address.address + " " + this.order.shipping_address.city + " " + this.order.shipping_address.zipcode + " " + this.order.shipping_address.province + " " + this.order.shipping_address.country;
      order.billing_address = this.order.billing_address.address + " " + this.order.billing_address.city + " " + this.order.billing_address.zipcode + " " + this.order.billing_address.province + " " + this.order.billing_address.country;
    }
    else{
      order.shipping_address = this.order.billing_address.address + " " + this.order.billing_address.city + " " + this.order.billing_address.zipcode + " " + this.order.billing_address.province + " " + this.order.billing_address.country;
      order.billing_address = this.order.billing_address.address + " " + this.order.billing_address.city + " " + this.order.billing_address.zipcode + " " + this.order.billing_address.province + " " + this.order.billing_address.country;
    }

    if(this.order.articles[0].id != 3){
      await this.orderService.saveOrder(this.modalData).then(async (d) => {
        order.settings_id = d.id;
        await this.orderService.postOrder(order).then(resp => {
          // console.log(resp)
          return promiseString = resp;
        });
      })
    }
    else{
      order.settings_id = "-";
      order.shipping_address = "-";
      order.shipment_method_id = 0;
      await this.orderService.postOrder(order).then(resp => {
        return promiseString = resp;
      });
    }
    this.orderId = promiseString.orderId;
    return Promise.resolve(promiseString);
  }

  renderKlarna(){
    let snippet;
    this.paymentService.klarnaCheckoutOrder(this.klarnaObj).then((res: any) =>{
      if(res['html_snippet']){
        snippet = res.html_snippet.replace(/\\"/g, "\"").replace(/\\n/g, "");
        this.klarnaAvailable = true;
        var checkoutContainer = document.getElementById('my-checkout-container')
        checkoutContainer.innerHTML = snippet;
        var scriptsTags = checkoutContainer.getElementsByTagName('script')
        // This is necessary otherwise the scripts tags are not going to be evaluated
        for (var i = 0; i < scriptsTags.length; i++) {
            var parentNode = scriptsTags[i].parentNode
            var newScriptTag = document.createElement('script')
            newScriptTag.type = 'text/javascript'
            newScriptTag.text = scriptsTags[i].text
            parentNode.removeChild(scriptsTags[i])
            parentNode.appendChild(newScriptTag)
        }
      }
    })
  }

  @HostListener('window:onKlarnaResponse', ['$event.detail'])
  onLogin(detail) {
    if(detail.klarnaResponse.approved){
      this.saveOrder().then(async (d) => {
        await this.paymentService.klarnaAuthoriseOrder(this.klarnaObj, detail.klarnaResponse.authorization_token);
        this.orderConfirmationWindow();
      })
    }
    else{
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.id = "order-failed-component";
      const modalDialog = this.matDialog.open(OrderFailedComponent, dialogConfig);
    }
  }
  
  @HostListener('window:onKlarnaPaymentInit', ['$event.detail'])
  onPaymentInit(detail) {
    this.klarnaAvailable = detail.klarnaResponse.show_form;
  }
  
  klarnaAutorize() {
    Klarna.Payments.authorize({
      payment_method_category: 'pay_later'
    }, this.klarnaObj, function (res) {
      var event = new CustomEvent('onKlarnaResponse', {
        detail: {
          klarnaResponse: res,
        }
      })
      window.dispatchEvent(event);
    })
  }

  klarnaAsyncCallback(client_token) {
    try {
      Klarna.Payments.init({
        client_token: client_token
      })
      Klarna.Payments.load({
        container: '#klarna-payments-container',
        payment_method_category: 'pay_later'
      }, function (res) {
        var event = new CustomEvent('onKlarnaPaymentInit', {
          detail: {
            klarnaResponse: res,
          }
        })
        window.dispatchEvent(event);
      })
    } catch (error) {
      console.log('Error', error)
    }
  }

  async ngOnInit() {
    paypal.Buttons({
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units:[
            {
                description: this.order.product_name,
                amount: {
                  currency_code: 'EUR',
                  value: this.order.total_price
                }
            }
          ]
        });
      },
      onApprove: async(data, actions) =>{
        const order = await actions.order.capture();
        await this.saveOrder();
        this.orderConfirmationWindow();
      },
      onError: err => {
        console.log(err)
        this.orderFailedWindow();
      }
    })
    .render(this.paypalElement.nativeElement);
    let productPrice
    let shippingPrice
    let totalPrice
    let productVat 
    let shippingVat 
    let totalVat 
    
    await this.orderService.getCurrencyRateByName(this.order.country.country).then((currencies: any)=>{
      if (currencies.length >= 1) {
        this.currencyRate = currencies[0].EUR_rate;
      } else {
        this.currencyRate = 1;
      }
    
      if(this.currencyRate != 1){
        let ratePrice = this.order.product_price * this.currencyRate
        let rateShipping = this.order.shipping_price * this.currencyRate
      
        productPrice = parseFloat((((ratePrice + parseFloat((ratePrice * this.order.country.vat).toFixed(5))) * 100)).toFixed(0))
        shippingPrice = parseFloat(((rateShipping + parseFloat((rateShipping * this.order.country.vat).toFixed(5))) * 100).toFixed(0))
        totalPrice = (productPrice * this.order.quantity) + shippingPrice
        productVat = parseFloat((parseFloat((ratePrice * this.order.country.vat * this.order.quantity).toFixed(5)) * 100).toFixed(0))
        shippingVat = parseFloat((parseFloat((rateShipping * this.order.country.vat).toFixed(5)) * 100).toFixed(0))
        totalVat = parseFloat((parseFloat(((rateShipping * this.order.country.vat) + (ratePrice * this.order.quantity * this.order.country.vat)).toFixed(5)) * 100).toFixed(0))
      }
      else{
        productPrice = parseFloat((((this.order.product_price + parseFloat((this.order.product_price * this.order.country.vat).toFixed(5))) * 100)).toFixed(0))
        shippingPrice = parseFloat(((this.order.shipping_price + parseFloat((this.order.shipping_price * this.order.country.vat).toFixed(5))) * 100).toFixed(0))
        totalPrice = (productPrice * this.order.quantity) + shippingPrice
        productVat = parseFloat((parseFloat((this.order.product_price * this.order.country.vat * this.order.quantity).toFixed(5)) * 100).toFixed(0))
        shippingVat = parseFloat((parseFloat((this.order.shipping_price * this.order.country.vat).toFixed(5)) * 100).toFixed(0))
        totalVat = parseFloat((parseFloat(((this.order.shipping_price * this.order.country.vat) + (this.order.product_price * this.order.quantity * this.order.country.vat)).toFixed(5)) * 100).toFixed(0))
      }
      
      let test = {
        order_amount: (this.order.total_price * 100),
        order_tax_amount: totalVat,
        name: 'Shipping',
        quantity: 1,
        tax_rate: parseFloat((this.order.country.vat * 10000).toFixed(0)) ,
        total_tax_amount: shippingVat ,
        total_amount: shippingPrice,
        unit_price: shippingPrice
      }

      this.klarnaObj = {
        purchase_country: this.order.country['alpha2_code'],
        purchase_currency: this.order.country.currency,
        locale: this.locale,
        billing_address: {
          given_name: this.order.user.firstname,
          family_name: this.order.user.lastname,
          email: this.order.user.email,
          street_address: this.order.billing_address.address,
          postal_code: this.order.billing_address.zipcode,
          city: this.order.billing_address.city,
          phone: this.order.phone_nr,
          country: this.order.billing_address.country
        },
        order_amount: totalPrice,
        order_tax_amount: totalVat,
        order_lines: [
          {
            name: this.order.product_name,
            quantity: this.order.quantity,
            tax_rate: parseFloat((this.order.country.vat * 10000).toFixed(0)),
            total_tax_amount: productVat,
            total_amount: productPrice * this.order.quantity,
            unit_price: productPrice
          },
          {
            name: 'Shipping',
            quantity: 1,
            tax_rate: parseFloat((this.order.country.vat * 10000).toFixed(0)) ,
            total_tax_amount: shippingVat ,
            total_amount: shippingPrice,
            unit_price: shippingPrice
          }
        ]
      }
      this.paymentService.klarnaInitiateSession(this.klarnaObj).then((res: any) => {
        this.klarnaClientToken = res.client_token
        this.klarnaAsyncCallback(this.klarnaClientToken)

      })
    });
  }
}
